module.exports = __webpack_public_path__ + "assets/5-Contact-Sales-Recruiters.836ca410.png";